export enum GalleryLayout {
    CAROUSEL = 'carousel',
    GRID = 'grid',
}

export interface Image {
    src: string
    thumbnail?: string
    caption: string
}
export interface GalleryImageClickContext {
    imageIndex: number
    layout: GalleryLayout
}

export interface GalleryProps {
    header?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    footer?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    images: Image[]
    video?: Image
    skipFullScreen?: boolean
    skipOverlay?: boolean
    showDots?: boolean
    showArrows?: boolean
    showCountTile?: boolean
    autoPlay?: boolean
    onSlideChange?: (index: number) => void
    imageBorderRadius?: string
    imageBorder?: string
    layout?: GalleryLayout
    onGalleryImageClick?: (context: GalleryImageClickContext) => void
    onViewAllClick?: () => void
    onFullscreenImageClick?: (imageIndex: number) => void
    onFullScreenOpen?: () => void
    onOverlayOpen?: () => void
    viewAllText?: string
    fontFamily?: string
    galleryIconSrc?: string
}

export interface FullScreenModalProps {
    images: Image[]
    video?: Image
    isFullScreenOpen: boolean
    isOverlayOpen: boolean
    setFullScreen: React.Dispatch<React.SetStateAction<boolean>>
    header?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    footer?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    setOverlay: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedImage: (index: number) => void
    currentIndex: number
    onFullscreenImageClick?: (imageIndex: number) => void
    onFullScreenOpen?: () => void
    shouldAutoplayVideo?: boolean
}

export interface OverlayModalProps {
    images: Image[]
    video?: Image
    isOverlayOpen: boolean
    setOverlay: React.Dispatch<React.SetStateAction<boolean>>
    initialSlide: number
    setSelectedImage: (index: number) => void
    footer?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    onOverlayOpen?: () => void
    shouldAutoplayVideo?: boolean
}

export interface OverlayCarouselProps {
    images: Image[]
    video?: Image
    setOverlay: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedImage: (index: number) => void
    isOverlayOpen: boolean
    initialSlide?: number
    footer?: (props: { onClose: () => void; activeImageIndex: number }) => React.JSX.Element
    onOverlayOpen?: () => void
    shouldAutoplayVideo?: boolean
}
